








import { Vue, Component } from 'vue-property-decorator';
import { Page } from '@/components/Page.vue';

@Component({
  name: 'Products',
  components: {
    Page,
  },
})
export default class Products extends Vue {

}
